import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
//Machines
import ServiceMachine from "../service/Machines/ServiceMachine";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "../BaseMixer";
import ServiceModule from "@/store/modules/service.module";
import { toaster } from "../../../utilities/toaster";
import { interpret } from "xstate";
import DeleteComponent from "@/components/deleteComponent.vue";
let Services = /** @class */ (() => {
    let Services = class Services extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.title = "Services";
            this.items = [
                {
                    text: "Services",
                    active: true,
                },
            ];
            this.pageIsLoading = true;
            this.showDeleteModal = false;
            //Machines
            // MACHINE
            this.machine = ServiceMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        AddService() {
            this.$router.push({ name: "ServiceAdd" });
        }
        editService(serviceId) {
            this.$router.push({ name: "ServiceUpdate", params: { id: serviceId } });
        }
        viewService(viewId) {
            this.$router.push({ name: "ViewService", params: { id: viewId } });
        }
        deleteService() {
            ServiceModule.DeleteService(this.delValueId).then((response) => {
                toaster.ShowSuccess("Service was deleted successfully. ");
                ServiceModule.GetServices().then((response) => { });
            });
            this.showDeleteModal = false;
        }
        openDeleteModal(valueId) {
            this.delValueId = valueId;
            this.showDeleteModal = true;
            this.pageIsLoading = false;
        }
        cancelService() {
            this.showDeleteModal = false;
        }
        // COMPUTED
        get values() {
            return ServiceModule.services;
        }
        // LIFECYCLE
        created() {
            this.machineService.onTransition((state) => {
                this.state = state;
            });
            this.machineService.start();
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    Services = __decorate([
        Component({
            name: "Services",
            components: {
                Layout,
                PageHeader,
                Loader,
                DeleteComponent,
            },
        })
    ], Services);
    return Services;
})();
export default Services;
